import React, { FC } from 'react';
import { TextContent } from 'components/energy5/structures';
import { Box, Container, Grid, Theme } from '@material-ui/core';
import NewContactUsForm from 'containers/common/form/NewContactUsForm';
import { Energy5BgAfter } from 'components/energy5/atoms';
import { makeStyles } from '@material-ui/styles';
import { useMediaQueries } from 'hooks';
import useI18n from "evcharging/hooks/useI18n";

const useStyles = makeStyles((theme: Theme) => ({
  text: {
    color: theme.palette.customColors.main,
  },
  container: {
    padding: theme.spacing(1, 0, 10),
    flexDirection: 'column-reverse',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      padding: theme.spacing(25, 0),
    },
  },
  contactWrapper: {
    marginBottom: theme.spacing(20),
    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
    },
  },
}));

const ContactUsSection: FC = () => {
  const { t } = useI18n();

  const classes = useStyles();
  const isMediumUp = useMediaQueries((theme: Theme) => theme.breakpoints.up('md'));

  return (
    <Box style={{ overflow: 'hidden' }}>
      <Container maxWidth={false} fixed>
        <Grid container className={classes.container} spacing={isMediumUp ? 6 : 0}>
          <Grid item lg={5} md={6} xs={12}>
            <TextContent
              title={t('contact-us.to')}
              text={t('contact-us.to-list')}
              textClassName={classes.text}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12}>
            <Energy5BgAfter className={classes.contactWrapper}>
              <NewContactUsForm />
            </Energy5BgAfter>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ContactUsSection;
